import { Text } from '@dixa/lib-shared-habla';

import { ConversationAutomationAuditLogEntry } from 'apis/auditLogs';

type RoutedThroughConditionProps = {
  node: ConversationAutomationAuditLogEntry<'AUTOMATION_CONDITION_NODE_VISITED'>;
};

export function RoutedThroughCondition({
  node: { matched: isMatching },
}: RoutedThroughConditionProps): JSX.Element {
  return (
    <Text.Paragraph>
      Condition · {isMatching ? 'Match' : 'No match'}
    </Text.Paragraph>
  );
}
